module.exports = __webpack_public_path__ + "static/media/mm-grid.f792e9b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mm-grid.svg
// module id = 196
// module chunks = 0